import React from 'react';
import { Row, Col } from 'antd';
import { rowDefaultProps, colTitleSublineProps } from 'src/utils/grid';
import { FormattedMessage } from 'react-intl';
import styles from './Subline.module.scss';

export interface SublineProps {
  text?: string;
  jsx?: JSX.Element;
  id?: string;
}

const Content: React.FC<SublineProps> = ({ text, jsx, id }) => {
  if (!id && !React.isValidElement(jsx) && !text) return null;

  if (id)
    return (
      <FormattedMessage id={id}>
        {(txt: string) => (
          <div className={styles.container} dangerouslySetInnerHTML={{ __html: txt }}></div>
        )}
      </FormattedMessage>
    );

  if (text) return <div className={styles.container} dangerouslySetInnerHTML={{ __html: text }} />;

  return <div className={styles.container}>{jsx}</div>;
};

const Subline: React.FC<SublineProps> = (props: SublineProps) => {
  const { text, id, jsx } = props;

  return (
    <Row {...rowDefaultProps}>
      <Col {...colTitleSublineProps}>
        <Content id={id} text={text} jsx={jsx} />
      </Col>
    </Row>
  );
};

export default Subline;
